import { createFileRoute } from '@tanstack/react-router';

import { ImportWizard } from '~/modules/partners/components/ImportWizard';

import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

const title = 'Partner importieren';

export const Route = createFileRoute(
  '/(main)/settings/partner-settings/import/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/partner-settings/import',
    ...routeParams,
  }),
  component: ImportWizard,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});
